import(/* webpackMode: "eager" */ "/app/main/app/[locale]/project/py/page.tsx");
